var Router = /** @class */ (function () {
    function Router(map) {
        var _this = this;
        this.map = map;
        this.route();
        this.map.on('moveend', function () {
            _this.updateRoute();
        });
    }
    Router.prototype.route = function () {
        var _this = this;
        var hash = window.location.hash;
        hash.split('/').forEach(function (p) {
            var xp = p.split(':');
            if (xp[0] == 'C' && xp.length == 2) {
                var _a = xp[1].split(';'), lat = _a[0], lng = _a[1], zoom = _a[2];
                _this.map.setZoom(zoom);
                _this.map.setCenter([lng, lat]);
            }
            if (xp[0] == 'S' && xp.length == 2) {
                _this.m_specie = xp[1];
            }
        });
    };
    Router.prototype.setSpecie = function (specie) {
        this.m_specie = specie;
        this.updateRoute();
    };
    Router.prototype.specie = function () {
        return this.m_specie;
    };
    Router.prototype.updateRoute = function () {
        var _a = this.map.getBounds().getCenter(), lat = _a.lat, lng = _a.lng;
        var zoom = this.map.getZoom();
        zoom = Math.round(zoom * 100) / 100;
        lat = Math.round(lat * 1000) / 1000;
        lng = Math.round(lng * 1000) / 1000;
        var hash = '/C:' + lat + ';' + lng + ';' + zoom;
        if (this.m_specie)
            hash += '/S:' + this.m_specie;
        window.location.hash = hash;
    };
    return Router;
}());
export { Router };
